import { render, staticRenderFns } from "./Task_Coin.vue?vue&type=template&id=306094a6&scoped=true"
import script from "./Task_Coin.vue?vue&type=script&lang=js"
export * from "./Task_Coin.vue?vue&type=script&lang=js"
import style0 from "./Task_Coin.vue?vue&type=style&index=0&id=306094a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306094a6",
  null
  
)

export default component.exports